<template>
  <v-card class="chat-container ma-auto" :style="{ fontFamily: theme.getFont }">
    <EcsCustomerChatHeader />
    <EcsCustomerChatBody />
    <EcsCustomerChatFooter />
  </v-card>
</template>

<script>
import EcsCustomerChatHeader from './ecs-customer-chat-header/EcsCustomerChatHeader';
import EcsCustomerChatBody from './ecs-customer-chat-body/EcsCustomerChatBody';
import EcsCustomerChatFooter from './ecs-customer-chat-footer/EcsCustomerChatFooter';
import { mapGetters } from 'vuex';
export default {
  name: 'EcsCustomerChat',
  components: {
    EcsCustomerChatHeader,
    EcsCustomerChatBody,
    EcsCustomerChatFooter
  },
  computed: mapGetters(['theme'])
};
</script>

<style scoped>
.chat-container {
  max-width: 500px;
}
</style>
